import { trpc } from '@/lib/trpc';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import useGetUser from '@/features/User/hooks/useGetUser';
import { List } from '../list';
import { useNavigate, useParams } from 'react-router-dom';

const useCreateList = () => {
	const utils = trpc.useUtils();
	const { t } = useTranslation();
	const { user } = useGetUser();
	const navigate = useNavigate();
	const { id_list } = useParams();

	const { mutate } = trpc.list.create.useMutation({
		onMutate: async (list) => {
			await utils.user.get.cancel();

			const listResponse = utils.list.get.getData() || {
				status: 200,
				lists: [],
			};

			const fakedList: List = {
				id: Math.random() * 100,
				name: list.name,
				created_at: new Date().toISOString(),
				updated_at: new Date().toISOString(),
				fk_user: user!.id,
				public_uid: '',
			};

			const optimisticLists = [...listResponse.lists, fakedList];

			utils.list.get.setData(undefined, () => {
				return { status: 200, lists: optimisticLists };
			});

			return { listResponse, fakeId: fakedList.id };
		},
		onSuccess: (data, _, { fakeId }) => {
			const listResponse = utils.list.get.getData() || {
				status: 200,
				lists: [],
			};

			utils.list.get.setData(undefined, () => {
				return {
					status: 200,
					lists: listResponse.lists.map((list) => {
						if (list.id === fakeId) {
							return {
								...list,
								public_uid: data.public_uid,
								id: data.id,
							};
						}
						return list;
					}),
				};
			});
			if (id_list && data.id) {
				navigate(`/list/${data.id}`);
			}
		},
		onError(_, __, context) {
			if (!context?.listResponse) return;
			utils.list.get.setData(undefined, () => {
				return { status: 200, lists: context?.listResponse.lists };
			});
			toast.error(t('error.generic'));
		},
	});

	return {
		createList: mutate,
	};
};

export default useCreateList;
